
import Vue, { PropType } from 'vue';
import { MethodOptions, MethodResult } from './typings/index';
import { MethodSelectorTile } from './components/MethodSelectorTile';
import { SupportedLangCodes } from '../../constants/languageCodes';
import customersAPI from '@/services/CustomersService';
import { mapState } from 'pinia';
import { useStore as useLangStore } from '@/stores/lang';

export default Vue.extend({
  components: {
    MethodSelectorTile,
  },

  model: {
    prop: 'methodResults',
    event: 'update:method-results',
  },

  props: {
    lang: {
      type: String as PropType<SupportedLangCodes>,
      required: false,
      default: 'en',
    },
    setLanguage: {
      type: Function,
      required: true,
    },
    methodResults: {
      type: Object as PropType<MethodResult>,
      required: true,
    },
    isFullDesignPathEnabled: {
      type: Boolean,
      default: false,
    },
    isFullDesignWithArtworksPathEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activeLanguage: this.lang,
      methodOptions: {
        logoOnlyMethodInformation: {
          items: [
            this.$t('flow-starter.items.upload-logo'),
            this.$t('flow-starter.items.add-text'),
            this.$t('flow-starter.items.various-print-positions'),
            this.$t('flow-starter.items.multiple-logos-per-print-position'),
            this.$t('flow-starter.items.different-design-options'),
          ],
          itemAvalabilities: [true, true, true, true],
        },
        personaliseMethodInformation: {
          items: [
            this.$t('flow-starter.items.upload-logo'),
            this.$t('flow-starter.items.add-text'),
            this.$t('flow-starter.items.various-print-positions'),
            this.$t('flow-starter.items.multiple-logos-per-print-position'),
            this.$t('flow-starter.items.different-design-options'),
          ],
          itemAvalabilities: [true, true, true, true, true, true],
        },
        fullDesignMethodInformation: {
          items: [
            this.$t('flow-starter.items.especially-available-for-you'),
            this.$t('flow-starter.items.upload-your-own-designed-proof'),
          ],
          itemAvalabilities: [true, true],
        },
      } as MethodOptions,
      isMethodPreselected: true,
    };
  },

  computed: {
    switchToLang(): string {
      return this.activeLanguage === 'en' ? 'nl' : 'en';
    },
    ...mapState(useLangStore, ['languageInUse']),
  },

  watch: {
    async languageInUse() {
      this.methodOptions = {
        logoOnlyMethodInformation: {
          items: [
            this.$t('flow-starter.items.upload-one-logo').toString(),
            this.$t(
              'flow-starter.items.logo-centralized-on-print-position'
            ).toString(),
            this.$t('flow-starter.items.maximal-print-size-is-used').toString(),
            this.$t(
              'flow-starter.items.receive-your-proof-within-two-hours'
            ).toString(),
          ],
          itemAvalabilities: [true, true, true, true],
        },
        personaliseMethodInformation: {
          items: [
            this.$t('flow-starter.items.upload-logo').toString(),
            this.$t('flow-starter.items.possible-to-add-text').toString(),
            this.$t('flow-starter.items.various-print-positions').toString(),
            this.$t(
              'flow-starter.items.multiple-logos-per-print-position'
            ).toString(),
            this.$t('flow-starter.items.different-design-options').toString(),
          ],
          itemAvalabilities: [true, true, true, true, true, true],
        },
        fullDesignMethodInformation: {
          items: [
            this.$t(
              'flow-starter.items.especially-available-for-you'
            ).toString(),
            this.$t(
              'flow-starter.items.upload-your-own-designed-proof'
            ).toString(),
          ],
          itemAvalabilities: [true, true],
        },
      };
    },
  },

  methods: {
    switchLang() {
      if (this.$route?.query?.lang === this.switchToLang) return;
      try {
        this.$router.push({
          query: {
            lang: this.switchToLang,
          },
        });
      } catch (e) {
        // Here we know, that we are not in the dev app context
        // as $router is not available
        this.activeLanguage = this.switchToLang;
        this.setLanguage(this.activeLanguage);
      }
    },
  },
});
